import { FC, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectIndustries } from "src/redux/industries/selectors";
import { selectInvestments } from "src/redux/investments/selectors";
import { selectPrices } from "src/redux/prices/selectors";
import { getIndustriesAsync } from "src/redux/industries/actions";
import { getInvestmentsAsync } from "src/redux/investments/actions";
import { getPricesAsync } from "src/redux/prices/actions";
import { ReactComponent as SavingsIcon } from "src/assets/icons/savings.svg";
import { ReactComponent as IndustryIcon } from "src/assets/icons/bag.svg";
import { ReactComponent as PriceIcon } from "src/assets/icons/cash.svg";
import { SearchDropdownList } from "./SearchDropdownList";
import { QueryParamKeys } from "./types";
import { searchTrns } from "./trns";

export const SearchOptions: FC = () => {
  const dispatch = useAppDispatch();

  const investments = useAppSelector(selectInvestments);
  const industries = useAppSelector(selectIndustries);
  const prices = useAppSelector(selectPrices);

  useEffect(() => {
    dispatch(getIndustriesAsync());
    dispatch(getInvestmentsAsync());
    dispatch(getPricesAsync());
  }, [dispatch]);

  return (
    <div className="flex flex-col lg:flex-row gap-6 lg:gap-10 relative">
      <SearchDropdownList
        className="w-50"
        title={searchTrns.minInvestment}
        icon={SavingsIcon}
        queryParamKey={QueryParamKeys.MIN_INVESTMENT}
        options={investments.data}
      />

      <SearchDropdownList
        className="w-30"
        title={searchTrns.industry}
        icon={IndustryIcon}
        queryParamKey={QueryParamKeys.INDUSTRY}
        options={industries.data}
      />

      <SearchDropdownList
        className="w-35"
        title={searchTrns.listPrice}
        icon={PriceIcon}
        queryParamKey={QueryParamKeys.LIST_PRICE}
        options={prices.data}
      />
    </div>
  );
};
